import { __extends } from "tslib";
import { AnimationNodeBase } from '@awayjs/renderer';
import { SkeletonBinaryLERPState } from '../states/SkeletonBinaryLERPState';
/**
 * A skeleton animation node that uses two animation node inputs to blend a lineraly interpolated output of a skeleton pose.
 */
var SkeletonBinaryLERPNode = /** @class */ (function (_super) {
    __extends(SkeletonBinaryLERPNode, _super);
    /**
     * Creates a new <code>SkeletonBinaryLERPNode</code> object.
     */
    function SkeletonBinaryLERPNode() {
        var _this = _super.call(this) || this;
        _this._pStateClass = SkeletonBinaryLERPState;
        return _this;
    }
    /**
     * @inheritDoc
     */
    SkeletonBinaryLERPNode.prototype.getAnimationState = function (animator) {
        return animator.getAnimationState(this);
    };
    return SkeletonBinaryLERPNode;
}(AnimationNodeBase));
export { SkeletonBinaryLERPNode };
